(function() {
'use strict';

angular
    .module('TR')
    .directive('hotelReview', hotelReview);

function hotelReview($location, authService, reviewService, $routeParams, modalService) {
    const domain = TRPCONFIG.Domain;

    function cultureMatches(review) {
        if (review == null || (review && review.CultureCode == null)) {
            return true;
        }
        return review.CultureCode.toLowerCase().substring(0, 2) ===
            domain.CultureCode.toLowerCase().substring(0, 2);
    }

    return {
        restrict: 'E',
        replace: true,
        scope: {
            review: '=',
            hotelName: '=',
            parentShown: '=',
            localShowHotelname: '@showHotelname',
            localShowHelpfulPrompt: '@showHelpfulPrompt'
        },
        templateUrl: 'partials/hotels/review',
        link(scope) {
            scope.showTranslation = 1;
            scope.showOriginal = 0;
            scope.translating = false;
            scope.review.ShowingTranslation = 1;

            scope.hotelName = scope.hotelName || '';
            scope.reviewTranslated = reviewTranslated;
            scope.organicLike = function() { _like('organic'); };
            scope.postSubmissionLike = function() { _like('postSubmission'); };
            scope.signIn = signIn;
            scope.modalSignIn = modalSignIn;
            scope.showHelpfulPrompt = true;
            scope.showHotelname = false;

            if (scope.localShowHotelname === 'true') {
                scope.showHotelname = true;
            }

            if (scope.localShowHelpfulPrompt === 'false') {
                scope.showHelpfulPrompt = false;
            }

            scope.$watch('review.ShowingTranslation', function(val, prev) {
                if (val === prev) {
                    return;
                }
                if (val === scope.showOriginal) {
                    if (scope.review.OriginalComments == null) {
                        scope.translating = true;
                        reviewService.getOriginalText(scope.review.ReviewId).then(function(data) {
                            scope.review.OriginalComments = scope.review.Comments = data.Comments;
                            scope.review.OriginalTopTip = scope.review.TopTip = data.TopTip;
                            scope.translating = false;
                        });
                    } else {
                        scope.review.Comments = scope.review.OriginalComments;
                        scope.review.TopTip = scope.review.OriginalTopTip;
                    }
                } else if (val === scope.showTranslation) {
                    scope.review.Comments = scope.review.TranslatedComments;
                    scope.review.TopTip = scope.review.TranslatedTopTip;
                }
            });

            if (
                (scope.review.Comments || scope.review.TopTip) &&
                !cultureMatches(scope.review) &&
                !scope.review.Translated &&
                !scope.review.TranslationFailed &&
                !TRPCONFIG.IsBot
            ) {
                //we need to try to translate this one
                scope.translating = true;
                reviewService.setTranslation(scope.review).then(function(data) {
                    scope.review.OriginalComments = scope.review.Comments;
                    scope.review.OriginalTopTip = scope.review.TopTip;
                    scope.review.Comments = scope.review.TranslatedComments = data.Comments;
                    scope.review.TopTip = scope.review.TranslatedTopTip = data.TopTip;
                    scope.review.ShowingTranslation = scope.showTranslation;
                    scope.review.Translated = true;
                    scope.translating = false;
                }, function() {
                    scope.review.TranslationFailed = true;
                    scope.translating = false;
                });
            }

            if ((scope.review.Comments || scope.review.TopTip) && !cultureMatches(scope.review) && scope.review.Translated) {
                scope.review.TranslatedComments = scope.review.Comments;
                scope.review.TranslatedTopTip = scope.review.TopTip;
            }

            if ($routeParams.lr && parseInt($routeParams.lr) === scope.review.ReviewId) {
                scope.organicLike();
            }

            function reviewTranslated() {
                return (scope.review.Comments || scope.review.TopTip) &&
                    !cultureMatches(scope.review) &&
                    scope.review.Translated;
            }

            function _like(reviewLikeType) {
                if (!scope.review.LikedByUser) {
                    reviewService.likeReview[reviewLikeType](scope.review.ReviewId, true).then(_postLike);
                }
            }

            function _postLike() {
                scope.review.LikedByUser = true;
                scope.review.LikeCount++;
            }

            function modalSignIn() {
                if (typeof scope.parentShown !== 'undefined') {
                    scope.parentShown = false;
                }
                const url = $location.path();
                authService.bufferRoute(url);
                modalService.launch('partials/auth/SignInPopUp', {
                    tab: 'signin',
                    cb() {
                        scope.organicLike();
                        if (typeof scope.parentShown !== 'undefined') {
                            scope.parentShown = true;
                        }
                    }
                });
            }

            function signIn() {
                const url = `${$location.path()}?pd=rv&lr=${scope.review.ReviewId}`;
                authService.bufferRoute(url);
                $location.url(`signin?cb=${encodeURIComponent(url)}`);
            }
        }
    };
}
})();
